import React, { useEffect, useState } from "react";
import HealthProfileMultiStageForm from "../../HealthProfileSetup/HealthProfle_Multistage_Form";

const UpdateProfileInformation = () => {
    return (
        <div>
             
            {/* Reuse HealthProfileMultiStageForm in edit mode */}
            <HealthProfileMultiStageForm isEditMode={true} />
        </div>
    );
};

export default UpdateProfileInformation;
